import { useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import myPic from "../images/myImg.svg";
import { contactData, serviceData } from "./projectData";
import Badge from 'react-bootstrap/Badge';
function Profile() {
    const [key, setKey] = useState('about');
    const emailIcon = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope-heart" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l3.235 1.94a2.8 2.8 0 0 0-.233 1.027L1 5.384v5.721l3.453-2.124q.219.416.55.835l-3.97 2.443A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741l-3.968-2.442q.33-.421.55-.836L15 11.105V5.383l-3.002 1.801a2.8 2.8 0 0 0-.233-1.026L15 4.217V4a1 1 0 0 0-1-1zm6 2.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132" />
    </svg>
    const whatsapp = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-whatsapp" viewBox="0 0 16 16">
        <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
    </svg>
    const visitIcon = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
        <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
    </svg>
    return (
        <Container className='py-5'>
            <Row>
                <Col sm={4} lg={4} xl={4} className='p-4 pt-0 profile_img_col pb-lg-4 pb-0'>
                    <img src={myPic} alt="img" height={250} width={250} className='' />
                    <br />
                    <p className='justify-content-center text-start p-3 pb-0 mb-0'>
                    </p>
                </Col>

                <Col sm={8} lg={8} xl={8} className='p-4'>
                    <div className='p-2'>
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                            className="mb-3"
                            variant="pills"
                        >
                            <Tab eventKey="about" title="About">
                                <h3>
                                    <div className="badge-base LI-profile-badge" data-locale="en_US" data-size="medium" data-theme="light" data-type="VERTICAL" data-vanity="divya-t-468642203" data-version="v1">
                                        <a className="badge-base__link LI-simple-link py-2" style={{ textDecoration: "none", color: "#e54b7cff" }} href="https://www.linkedin.com/in/divyatailang?trk=profile-badge" target='_/divya'>{`Divya Tailang`}</a></div>
                                </h3>
                                <strong>UI Developer | UI/UX Designer | Writer | Artist | Self Learner</strong>
                                <hr />
                                <small className='text-muted'>#learning #artist #gamer #code #creativity #Self-motivated #self-dedicated #self learner</small>

                                <p className='mt-2'>
                                    Hi, I’m Divya — A UI/UX Designer passionate about turning ideas into designs that feel effortless and enjoyable to use.
                                    With 5 years of experience, I love blending creativity with problem-solving to craft digital experiences that connect with people.
                                </p>

                            </Tab>
                            <Tab eventKey="contact" title="Contact" >
                                <div className='py-2'>
                                    <h3>Feel Free to Visit my all contact links </h3>
                                    <div className='py-3'>
                                        {contactData.map((contact, id) => (
                                            <Badge key={id} bg={contact.variant} className="fade-in custom-badge m-2">
                                                <a href={contact.link} target="_contact" className="text-decoration-none p-0 contact-link">
                                                    <span className="contact-title">{contact.title}</span> {visitIcon}
                                                </a>
                                            </Badge>
                                        ))}

                                    </div>
                                    <h5>
                                        Need A Web Developer & Designer
                                    </h5>
                                    <div style={{
                                        background: "rgb(67 82 82 / 16%)",
                                        padding: "25px",
                                        borderRadius: "12px"
                                    }}>
                                        <p className='g-2'>
                                            <span className='text-danger'>
                                                {emailIcon}
                                            </span> Send me an Email:
                                            <a href="mailto: divyatlng0@gmail.com" target='_mail'
                                                className='text-decoration-none text-success'> divyatlng0@gmail.com</a>
                                        </p>
                                        <p className='g-2'>
                                            <span className='text-danger'>
                                                {whatsapp}
                                            </span> Whatsapp Contact:
                                            <a href="tel: +917019898582" target='_mail'
                                                className='text-decoration-none text-success'> +917019898582</a>
                                        </p>
                                    </div>
                                </div>

                            </Tab>
                            
                            <Tab eventKey="services" title="Services" >
                                <h3>
                                    What I Offer
                                </h3>
                                <div style={{
                                    background: "rgb(67 82 82 / 16%)",
                                    padding: "25px",
                                    borderRadius: "12px"
                                }}>

                                    <ul>
                                        {serviceData.map((service, id) => (
                                            <li key={id} variant={service.variant} >
                                                <a href={service.link} target='_contact' className='text-decoration-none p-0' style={{ color: "rgb(166, 166, 166)" }}>
                                                    {service.title}
                                                </a>

                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Tab>

                        </Tabs>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default Profile;